import { ISamInventory } from '../../../interfaces/service/SandboxServiceManagerInterface';
import {
  GET_SANDBOX,
  GET_SANDBOX_ERROR,
  GET_SANDBOX_EXCEL,
  GET_SANDBOX_EXCEL_ERROR,
  GET_SANDBOX_EXCEL_SUCCESS,
  GET_SANDBOX_SUCCESS,
  getSandbox_Red,
  initialStateGetSandbox,
} from '../../../business/Reducers/sandbox/sandboxReducer';
import { useReducer } from 'react';

export const useGetSandboxState = () => {
  const [state, dispatch] = useReducer(getSandbox_Red, initialStateGetSandbox);

  function initGetSandbox() {
    dispatch({ type: GET_SANDBOX });
  }

  function getSandboxSuccess(data: ISamInventory[]) {
    dispatch({ type: GET_SANDBOX_SUCCESS, payload: data });
  }
  function getSandboxError(error: string) {
    dispatch({ type: GET_SANDBOX_ERROR, payload: error });
  }
  function initGetSandboxExport() {
    dispatch({ type: GET_SANDBOX_EXCEL });
  }

  function getSandboxExportSuccess(data: any) {
    dispatch({ type: GET_SANDBOX_EXCEL_SUCCESS, payload: data });
  }
  function getSandboxExportError(error: string) {
    dispatch({ type: GET_SANDBOX_EXCEL_ERROR, payload: error });
  }
  return {
    state,
    initGetSandbox,
    getSandboxSuccess,
    getSandboxError,
    initGetSandboxExport,
    getSandboxExportSuccess,
    getSandboxExportError,
  };
};
